import { combineReducers } from 'redux'
import appSlice from 'store/slices/app.slice'

const rootReducers = combineReducers({
  app: appSlice.reducer,
})

export default rootReducers
